import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  Adres, BokkzAlgDataService, IncomeTaxEntity,
  Lening,
  OmschrijvingEnBedrag,
  Persoon
} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-financieringskosten',
  templateUrl: './financieringskosten.component.html',
  imports: [
    SharedUiButtonModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ],
  styleUrls: ['./financieringskosten.component.scss']
})
export class FinancieringskostenComponent implements OnInit , OnDestroy{

    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;

    public leningenFG= {} as FormGroup;

    public index = 0;

    public soortFinancieringskosten: SelectFormControlItem<string>[] = [
        {value: 'Taxatiekosten', label: "Taxatiekosten"},
        {value: 'Notariskosten', label: "Notariskosten"},
        {value: 'Bemiddelingskosten', label: "Bemiddelingskosten"},
        {value: 'Kosten NHG', label: "Kosten NHG"},
        {value: 'Overige kosten', label: "Overige kosten"},
    ];

    constructor(private fb: FormBuilder, private router: Router, public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
        this.leningenFG = this.fb.group({
            leningen: this.fb.array<Lening>([]),
        });
    }

    //lening
    get leningen(): FormArray {
        return this.leningenFG.get('leningen') as FormArray;
    }

    addLening(): void {
        const lening = this.createLeningenFormGroup();
        this.leningen.push(lening);
        this.addKosten(0)
    }


    //kosten
    //aankoopkosten
    getKosten(index: number): FormArray {
        const outerGroup = this.leningen.at(index) as FormGroup;
        return outerGroup.get('kosten') as FormArray;
    }

    addKosten(index: number): void {
        const innerGroup = this.fb.group<OmschrijvingEnBedrag>({
            omschrijving: null as unknown as string,
            bedrag: null as unknown as number,
        });
        const outerGroup = this.leningen.at(index) as FormGroup;
        const innerArray = outerGroup.get('kosten') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteKosten(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getKosten(outerIndex);
        innerArray.removeAt(innerIndex);
        this.leningenFG.updateValueAndValidity()
        this.leningenFG.markAsDirty()
       this.saveForm()
    }

    createLeningenFormGroup(lening?: Lening) {
        return this.fb.group({
                omschrijving: lening?.omschrijving || undefined,
                bedrag: lening?.bedrag || undefined,
                rekeningNummer: lening?.rekeningNummer || undefined,
                landCode: lening?.landCode || undefined,
                aanwending: lening?.aanwending || undefined,
                geldVerstrekker: lening?.geldVerstrekker || undefined,
                wozNummerWaarLeningBijHoort: lening?.wozNummerWaarLeningBijHoort || undefined,
                percentageBox1: lening?.percentageBox1 || 100,
                hoofdsom0101: lening?.hoofdsom0101 || 0,
                hoofdsom3112: lening?.hoofdsom3112 || 0,
                rente: lening?.rente || undefined,
                kosten: this.fb.array<OmschrijvingEnBedrag>([]),
                personeelsKorting: lening?.personeelsKorting || undefined,
                aanvangsDatum: lening?.aanvangsDatum || undefined,
                eindDatum: lening?.eindDatum || undefined,
                oorspronkelijkeHoofdsom: lening?.oorspronkelijkeHoofdsom || undefined,
                rentePercentageDecimalen: lening?.rentePercentageDecimalen || undefined,
                aflossingsMethode: lening?.aflossingsMethode || undefined,
                naamLeninggever: this.fb.group<Persoon>({
                    roepnaam: lening ? lening.naamLeninggever?.roepnaam : undefined,
                    voorletters: lening ? lening.naamLeninggever?.voorletters : undefined,
                    tussenvoegsels: lening ? lening.naamLeninggever?.tussenvoegsels : undefined,
                    achternaam: lening ? lening.naamLeninggever?.achternaam : undefined,
                    bsn: lening ? lening.naamLeninggever?.bsn : undefined,
                    geboortedatum: lening ? lening.naamLeninggever?.geboortedatum : undefined,
                    overlijdensdatum: lening ? lening.naamLeninggever?.overlijdensdatum : undefined,
                    landCodeNationaliteit: lening ? lening.naamLeninggever?.landCodeNationaliteit : undefined
                }),
                adresLeninggever: this.fb.group<Adres>({
                    straat: lening ? lening.adresLeninggever?.straat : undefined,
                    huisNummer: lening ? lening.adresLeninggever?.huisNummer : undefined,
                    huisNummerToevoeging: lening ? lening.adresLeninggever?.huisNummerToevoeging : undefined,
                    postcode: lening ? lening.adresLeninggever?.postcode : undefined,
                    woonplaats: lening ? lening.adresLeninggever?.woonplaats : undefined,
                    landCode: lening ? lening.adresLeninggever?.landCode : undefined,
                }),
            }
        )
    }

    public createOmschrijvingEnBedragFormGroup(omschrijving?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: omschrijving ? omschrijving.omschrijving : null as unknown as string,
            bedrag: omschrijving ? omschrijving.bedrag : null as unknown as number,
        } as OmschrijvingEnBedrag))
    }



    formStructure: any;
    leningLength: any

    public ngOnInit(): void {
      this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.updateForm()
                this.leningenFG.valueChanges.subscribe(value => {
                    this.formStructure = value;
                });
                this.leningen.valueChanges.subscribe(value => {
                    this.leningLength = value
                });
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      });
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.leningenFG.dirty;
  }

    private updateForm(): void {
        const leningenLijst = this.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.leningen || [];
        const formArray = this.leningenFG.get('leningen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > leningenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Update leningen
        for (let i = 0; i < leningenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(leningenLijst[i]);
            } else {
                const formGroup = this.createLeningenFormGroup(leningenLijst[i])
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }

        // Update kosten lening (k)
        for (let i = 0; i < leningenLijst.length; i++) {
            const lening = leningenLijst[i];
            const kosten = lening.kosten || [];
            const kostenFormArray = this.getKosten(i);

            while (kostenFormArray.length > kosten.length) {
                kostenFormArray.removeAt(kostenFormArray.length - 1);
            }

            for (let k = 0; k < kosten.length; k++) {
                if (k < kostenFormArray.length) {
                    const control = kostenFormArray.at(k) as FormGroup;
                    control.patchValue(kosten[k]);
                } else {
                    const kost = this.createOmschrijvingEnBedragFormGroup(kosten[k]);
                    kostenFormArray.push(kost);
                }
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
            box1: {
                ...this.aangifte.box1,
                belastbareInkomstenUitEigenWoning: {
                    ...this.aangifte.box1?.belastbareInkomstenUitEigenWoning,
                    leningen: this.leningenFG.value.leningen
                }
            }
        } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            this.leningenFG.markAsDirty()
        }, 0)
    }

}

